import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { Question } from 'types/question.types';
import { EventFeedbackSettings } from 'types/questions.types';

import { UpdateQuestionInput } from '../question.types';
import { FeedbackQuestionsFragment, FeedbackSettingsFragment } from '../common';

export interface UpdateEventFeedbackQuestionInput {
  eventId: number;
  question: UpdateQuestionInput;
}

export interface UpdateEventFeedbackQuestionResult {
  updateEventFeedbackQuestion: {
    ok: boolean;
    event: {
      id: number;
    } & EventFeedbackSettings;
    question: Question;
  };
}

const UpdateEventFeedbackQuestionMutation = gql`
  mutation updateEventFeedbackQuestion($input: UpdateEventFeedbackQuestionInput!) {
    updateEventFeedbackQuestion(input: $input) {
      ok
      event {
        id
        ...FeedbackSettingsFragment
      }
      question {
        ...FeedbackQuestionsFragment
      }
    }
  }
  ${FeedbackQuestionsFragment}
  ${FeedbackSettingsFragment}
`;

export const updateEventFeedbackQuestion = (
  input: UpdateEventFeedbackQuestionInput
): Promise<UpdateEventFeedbackQuestionResult> => {
  return gqlClient.request<UpdateEventFeedbackQuestionResult>(UpdateEventFeedbackQuestionMutation, {
    input
  });
};
